import * as React from 'react';
import { PremiumDomainConnectSecondStep } from 'owa-domain-connect';
import { showModal } from 'owa-modal';

export async function launchDomainConnectSetAlias(
    domain: string,
    csrfToken: string
): Promise<void> {
    mountDomainConnectSecondStep(domain, csrfToken);
}

function mountDomainConnectSecondStep(domain: string, csrfToken: string) {
    const WrappedComponent = () => (
        <PremiumDomainConnectSecondStep
            domainName={domain}
            csrfToken={csrfToken}
            mountFromDomainDashBoard={false}
            isSecondaryUser={false}
        />
    );
    showModal(WrappedComponent);
}
